module.exports = __webpack_public_path__ + "static/media/broken-string-guitar-broken.a2d1dce8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/broken-string-guitar-broken.gif
// module id = 805
// module chunks = 0